export type HistoriskAdkomstEntry = {
   dato: string;
   navn: string;
};

function decodeBase64Utf8(value: string): string {
   const binary = atob(value);
   const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
   return new TextDecoder().decode(bytes);
}

export function parseHistoriskeAdkomsterXml(xml: string): HistoriskAdkomstEntry[] {
   const cleaned = xml.replace(/(<\/?)([^\s>]*?:)?/g, "$1");
   return cleaned.split(/<EjendomHistoriskAdkomst>/).slice(1).flatMap((block) => {
      const chunk = block.split("</EjendomHistoriskAdkomst>")[0] || "";
      const dato = (chunk.match(/<HistoriskAdkomstDato[^>]*>([^<]+)/)?.[1] || "").split("T")[0].split("+")[0];
      const encoded = (chunk.match(/<AsciiTekst[^>]*>([^<]+)/)?.[1] || "").replace(/\s+/g, "");
      if (!encoded) return [];
      let navn = "";
      try {
         navn = decodeBase64Utf8(encoded).trim();
      } catch {
         navn = "";
      }
      if (!navn) return [];
      return [{ dato, navn }];
   });
}

/** Latest owner names on or before the deed date. Same date means co-owners. */
export function latestHistoriskAdkomstEjere(
   entries: HistoriskAdkomstEntry[],
   beforeDate?: string,
): HistoriskAdkomstEntry[] {
   const cutoff = beforeDate?.slice(0, 10);
   const pool = cutoff ? entries.filter((entry) => entry.dato && entry.dato < cutoff) : entries;
   if (!pool.length) return [];
   const latestDate = pool.reduce((max, entry) => (entry.dato > max ? entry.dato : max), "");
   return pool.filter((entry) => entry.dato === latestDate);
}
